export const SIDEBAR = {
  width: 280,
  collapsed: {
    width: 56,
  },
};
